<template lang="pug">
  tbody
    tr
      th(colspan=2) {{ lottery_1d_title }}
      td
        PTSelect(
          ref="lottery_1d_upline_pt"
          :dirty="$v.lottery_1d_upline_pt.$dirty"
          :error="$v.lottery_1d_upline_pt.$error"
          :options="lottery_1d_upline_options"
          :value="lottery_1d_upline_pt"
          @input="input_lottery_1d_upline_pt"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="lottery_1d_account_pt"
          :dirty="$v.lottery_1d_account_pt.$dirty"
          :error="$v.lottery_1d_account_pt.$error"
          :options="lottery_1d_account_options"
          :value="lottery_1d_account_pt"
          @input="input_lottery_1d_account_pt"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="lottery_1d_upline_remaining"
          :dirty="$v.lottery_1d_upline_remaining.$dirty"
          :error="$v.lottery_1d_upline_remaining.$error"
          :options="lottery_1d_account_options"
          :value="lottery_1d_upline_remaining"
          @input="$v.lottery_1d_upline_remaining.$model = $event"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="lottery_1d_account_min"
          :dirty="$v.lottery_1d_account_min.$dirty"
          :error="$v.lottery_1d_account_min.$error"
          :options="lottery_1d_min_options"
          :value="lottery_1d_account_min"
          @input="$v.lottery_1d_account_min.$model = $event"
          :disabled="loading"
        )
    tr
      th(colspan=2) {{ lottery_2d_title }}
      td
        PTSelect(
          ref="lottery_2d_upline_pt"
          :dirty="$v.lottery_2d_upline_pt.$dirty"
          :error="$v.lottery_2d_upline_pt.$error"
          :options="lottery_2d_upline_options"
          :value="lottery_2d_upline_pt"
          @input="input_lottery_2d_upline_pt"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="lottery_2d_account_pt"
          :dirty="$v.lottery_2d_account_pt.$dirty"
          :error="$v.lottery_2d_account_pt.$error"
          :options="lottery_2d_account_options"
          :value="lottery_2d_account_pt"
          @input="input_lottery_2d_account_pt"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="lottery_2d_upline_remaining"
          :dirty="$v.lottery_2d_upline_remaining.$dirty"
          :error="$v.lottery_2d_upline_remaining.$error"
          :options="lottery_2d_account_options"
          :value="lottery_2d_upline_remaining"
          @input="$v.lottery_2d_upline_remaining.$model = $event"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="lottery_2d_account_min"
          :dirty="$v.lottery_2d_account_min.$dirty"
          :error="$v.lottery_2d_account_min.$error"
          :options="lottery_2d_min_options"
          :value="lottery_2d_account_min"
          @input="$v.lottery_2d_account_min.$model = $event"
          :disabled="loading"
        )
</template>

<script>
import { required, minValue } from "vuelidate/lib/validators";
import PTSelect from "@/library/PTSelect";

export default {
  components: {
    PTSelect
  },
  props: {
    loading: false,
    accountID: ""
  },
  data() {
    return {
      lottery_1d_upline_pt: 0,
      lottery_1d_account_pt: 0,
      lottery_1d_upline_remaining: 0,
      lottery_1d_account_min: 0,
      lottery_2d_upline_pt: 0,
      lottery_2d_account_pt: 0,
      lottery_2d_upline_remaining: 0,
      lottery_2d_account_min: 0
    }
  },
  validations() {
    return {
      lottery_1d_upline_pt: {
        required,
        minValue(value) {
          if(this.$helpers.isPlatformEnabled('LT')) {
            let total = 0
            if(this.$helpers.isAgentLevel()) {
              total = value
            } else {
              total = value + this.lottery_1d_account_pt
            }
            if(total < this.lottery_1d_upline_min) {
              return false
            } else {
              return true
            }
          } else {
            return true
          }
        }
      },
      lottery_1d_account_pt: {
        required,
        minValue(value) {
          if(this.$helpers.isPlatformEnabled('LT')) {
          let total = 0
          if(this.$helpers.isAgentLevel()) {
              return true
            } else {
              total = value + this.lottery_1d_upline_pt
              if(total < this.lottery_1d_upline_min) {
                return false
              } else {
                return true
              }
            }
          } else {
            return true
          }
        }
      },
      lottery_1d_upline_remaining: {
        required
      },
      lottery_1d_account_min: {
        required
      },
      lottery_2d_upline_pt: {
        required,
        minValue(value) {
          if(this.$helpers.isPlatformEnabled('LO')) {
            let total = 0
            if(this.$helpers.isAgentLevel()) {
              total = value
            } else {
              total = value + this.lottery_2d_account_pt
            }
            if(total < this.lottery_2d_upline_min) {
              return false
            } else {
              return true
            }
          } else {
            return true
          }
        }
      },
      lottery_2d_account_pt: {
        required,
        minValue(value) {
          if(this.$helpers.isPlatformEnabled('LO')) {
            let total = 0
            if(this.$helpers.isAgentLevel()) {
              return true
            } else {
              total = value + this.lottery_2d_upline_pt
              if(total < this.lottery_2d_upline_min) {
                return false
              } else {
                return true
              }
            }
          } else {
            return true
          }
        }
      },
      lottery_2d_upline_remaining: {
        required
      },
      lottery_2d_account_min: {
        required
      }
    }
  },
  computed: {
    isSearch: function() {
      if(this.accountID) {
        return !(this.accountID.length > 8)
      } else {
        return !this.$helpers.isAgentLevel()
      }
    },
    lottery_1d_title: function () {
      return this.$t("ui.lottery_1d") + " (" + this.lottery_1d_upline_min + "%-" + this.lottery_1d_upline_max + "%)"
    },
    lottery_1d_upline_min: function() {
      return this.$store.getters.getPTLT[0].account_min
    },
    lottery_1d_upline_max: function() {
      return this.$store.getters.getPTLT[0].account_pt
    },
    lottery_1d_account_max: function() {
      return this.lottery_1d_upline_max - this.lottery_1d_upline_pt
    },
    lottery_1d_upline_options: function() {
      return this.$helpers.getPTRateList(this.lottery_1d_upline_max)
    },
    lottery_1d_account_options: function() {
      return this.$helpers.getPTRateList(this.lottery_1d_account_max)
    },
    lottery_1d_min_options: function() {
      return this.$helpers.getPTRateList(this.lottery_1d_account_pt)
    },
    lottery_2d_title: function () {
      return this.$t("ui.lottery_2d") + " (" + this.lottery_2d_upline_min + "%-" + this.lottery_2d_upline_max + "%)"
    },
    lottery_2d_upline_min: function() {
      return this.$store.getters.getPTLT[1].account_min
    },
    lottery_2d_upline_max: function() {
      return this.$store.getters.getPTLT[1].account_pt
    },
    lottery_2d_account_max: function() {
      return this.lottery_2d_upline_max - this.lottery_2d_upline_pt
    },
    lottery_2d_upline_options: function() {
      return this.$helpers.getPTRateList(this.lottery_2d_upline_max)
    },
    lottery_2d_account_options: function() {
      return this.$helpers.getPTRateList(this.lottery_2d_account_max)
    },
    lottery_2d_min_options: function() {
      return this.$helpers.getPTRateList(this.lottery_2d_account_pt)
    }
  },
  mounted: function() {
    if(this.$helpers.isAgentLevel()) {
      this.$v.lottery_1d_upline_pt.$model = this.lottery_1d_upline_max
      this.$v.lottery_2d_upline_pt.$model = this.lottery_1d_upline_max
    }
    if(!this.$helpers.isPlatformEnabled('LT')) {
      this.$v.lottery_1d_upline_pt.$model = this.lottery_1d_upline_min
      this.$v.lottery_2d_upline_pt.$model = this.lottery_2d_upline_min
    }
  },
  methods: {
    input_lottery_1d_upline_pt(e) {
      this.$v.lottery_1d_upline_pt.$model = e
      this.$v.lottery_1d_account_pt.$model = this.lottery_1d_account_max

      if (this.lottery_1d_upline_remaining > this.lottery_1d_account_max) {
        this.$v.lottery_1d_upline_remaining.$model = 0
      }
      if (this.lottery_1d_account_min > this.lottery_1d_account_pt) {
        this.$v.lottery_1d_account_min.$model = 0
      }
    },
    input_lottery_1d_account_pt(e) {
      this.$v.lottery_1d_account_pt.$model = e
      if (this.lottery_1d_account_min > this.lottery_1d_account_pt) {
        this.$v.lottery_1d_account_min.$model = 0
      }
    },
    input_lottery_2d_upline_pt(e) {
      this.$v.lottery_2d_upline_pt.$model = e
      this.$v.lottery_2d_account_pt.$model = this.lottery_2d_account_max

      if (this.lottery_2d_upline_remaining > this.lottery_2d_account_max) {
        this.$v.lottery_2d_upline_remaining.$model = 0
      }
      if (this.lottery_2d_account_min > this.lottery_2d_account_pt) {
        this.$v.lottery_2d_account_min.$model = 0
      }
    },
    input_lottery_2d_account_pt(e) {
      this.$v.lottery_2d_account_pt.$model = e
      if (this.lottery_2d_account_min > this.lottery_2d_account_pt) {
        this.$v.lottery_2d_account_min.$model = 0
      }
    }
  }
}

</script>